// Dubai guide: Dubai Fitness Challenge training plan. Avoids fixed dates for
// the challenge (they change yearly); refers to "around November".
const content = {
    slug: 'dubai-fitness-challenge-training-plan',
    title: 'Dubai Fitness Challenge Training Plan | 30 Days, 30 Minutes',
    description: 'A 30-day plan for the Dubai Fitness Challenge: 30 minutes a day, four weeks that build on each other, and how to keep going after the challenge ends.',
    eyebrow: 'Dubai · Fitness guide',
    h1: 'Dubai Fitness Challenge: A 30-Day Training Plan That Lasts',
    lead: 'Every year around November, Dubai sets itself one goal: 30 minutes of activity a day for 30 days. Here is a simple four-week plan to get through it without burning out - and to keep the habit once the free events end.',
    datePublished: '2026-10-03',
    image: 'blog/health+and+fitness/Functional-training.webp',
    imageAlt: 'Outdoor functional training session in Dubai',
    summary: {
        title: 'The challenge in brief',
        items: [
            'Goal: at least 30 minutes of activity every day for 30 days.',
            'Free fitness villages, classes and community events across the city.',
            'Big set-piece days like the Dubai Run and Dubai Ride on Sheikh Zayed Road.',
            'Any activity counts: walking, gym, sport, swimming, cycling.',
        ],
    },
    sections: [
        {
            title: 'Week 1: Build the habit',
            paragraphs: [
                'Keep it easy so day 7 feels as doable as day 1. Alternate brisk 30-minute walks - the beach, the Marina walk or a park in the cooler evenings - with two short bodyweight sessions: squats, push-ups against a bench, lunges and planks.',
            ],
        },
        {
            title: 'Week 2: Add strength',
            paragraphs: [
                'Three strength sessions this week, 30 minutes each, using your building gym or dumbbells at home. On the other days, walk, swim or join a free class at one of the fitness villages. If you are aiming for the Dubai Run, add one longer walk or easy jog.',
            ],
        },
        {
            title: 'Week 3: Push a little',
            paragraphs: [
                'Lengthen one session to 45 minutes and add intervals to one cardio day - one minute fast, two minutes easy. Keep one full rest-style day of gentle stretching or a stroll: it still counts as activity and stops niggles turning into injuries.',
            ],
        },
        {
            title: 'Week 4: Make it stick',
            paragraphs: [
                'Pick the three sessions you enjoyed most and turn them into your weekly routine for December. Book them like meetings. If you did the challenge with friends or colleagues, agree one shared session a week after it ends.',
            ],
        },
        {
            title: 'Staying safe',
            items: [
                'Train in the early morning or evening - midday can still be very warm.',
                'Drink before you feel thirsty and carry water on runs and rides.',
                'Start slower than you think, especially if you were inactive over summer.',
                'Stop if you feel chest pain, dizziness or unusual breathlessness, and see a doctor.',
            ],
        },
    ],
    faqs: [
        {
            question: 'What counts towards the Dubai Fitness Challenge?',
            answer: 'Any 30 minutes of physical activity a day - walking, running, gym, swimming, cycling, yoga, team sport.',
        },
        {
            question: 'Do I need a personal trainer for the challenge?',
            answer: 'No, but a trainer helps beginners start safely and gives you a plan to continue after the 30 days.',
        },
    ],
    cta: {
        title: 'Keep going after day 30',
        body: (c) => `A personal trainer at home or in your building gym, from ${c.money(c.lowest, 0)} a session.`,
        href: '/ae/personal-trainer-dubai',
        label: 'Personal trainers in Dubai',
    },
}

export default content
